import React from "react";
import {FaFacebook} from 'react-icons/fa';
import {FaWhatsapp} from 'react-icons/fa';
import {FaTwitter} from 'react-icons/fa';
import "./footer.css"
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import imagen from "../../Assets/footerBackground.png"

function Footer() {
    return (
        <>
        
            {/*<div className="footerContainer" style={{ backgroundImage: `url(${imagen})` }}>*/}
                
                <div class="footerWrapContent">
                <div className="footerText">
                     Aviso de privacidad    |   Terminos y Condiciones
                    </div>

                    </div>
                
              {/*</div>*/}
        </>
    );
}
export default Footer